import {NewsError} from './NewsError.js'

export class SubscribeToNewsletterError extends NewsError {}
